import { Box, BoxStatus, GraphicContainer, OpePanel } from "codekit";
import { useSelector } from "react-redux";
import { getDataUser } from "../../../../libs/redux/slices/authSlice/authSlice";
import { useGetOpePanelDataQuery } from "../../../../libs/redux/slices/Graficsx/Opepanel/opepanelApiSlice";
import { useGetUrlRedirectCimaMutation } from "../../../../libs/redux/slices/Graficsx/graficsxApiSlice";

/**
 * Grafica Panel de operaciones aduaneras
 * @author devpremier
 * @since 2026-04-21
 */
const Opepanel = ({ graphName }) => {
  const { USRNOMXX } = useSelector(getDataUser);
  const { data: response, isLoading } = useGetOpePanelDataQuery();
  const opePanelData = response?.data;
  const [getUrlRedirectCima] = useGetUrlRedirectCimaMutation();

  // Redireccionamiento de operaciones
  const handleClickChart = async (context) => {
    const operations = context.ids ?? [];
    if (operations.length === 0) {
      return;
    }
    const payload = {
      MODIDXXX: "117",
      PROIDXXX: "100",
      [`filters[0][MDOSYYYY.DOCNROXX][IN]`]: operations,
    };
    await getUrlRedirectCima(payload)
      .unwrap()
      .then((response) => window.open(response.data, "_blank"))
      .catch();
  };
  // Redireccionamiento de una operacion
  const handleClickDO = async (context) => {
    await handleClickChart({ ids: [context.id] });
  };

  if (isLoading) {
    return (
      <Box spacing={5}>
        <BoxStatus variant="loading" text="Cargando información..." />
      </Box>
    );
  }

  if (!opePanelData) {
    return null;
  }

  return (
    <Box spacing={5}>
      <GraphicContainer containerName={graphName}>
        <OpePanel
          userName={USRNOMXX}
          chartData={opePanelData.chartData}
          tabs={opePanelData.tabs}
          tabStats={opePanelData.tabStats}
          doData={opePanelData.doData}
          onClickTracking={handleClickChart}
          onClickDo={handleClickDO}
        />
      </GraphicContainer>
    </Box>
  );
};

export default Opepanel;
